import { Head, usePage } from '@inertiajs/react'
import { Box } from '@mui/material'
import { ToursTab, ProspectMainLayout } from '../../components'

interface TourRequest {
    id: string
    status: 'pending' | 'accepted' | 'declined' | 'expired'
    listing: {
        title: string
        neighborhood: string
        address: string
        rent: number
        bedrooms: number
        bathrooms: number
        photos: string[]
    }
    landlord: {
        name: string
        avatar: string | null
    }
    requested_date: string
    requested_time: string
    message?: string
    match_score: number
    rejection_reason?: string
    listing_url: string
    listing_contact_email: string
}

interface ToursPageProps {
    pending_not_expired?: TourRequest[]
    pending_expired?: TourRequest[]
    accepted_past?: TourRequest[]
    accepted_upcoming?: TourRequest[]
}

export default function ToursPage({
    pending_not_expired = [],
    pending_expired = [],
    accepted_past = [],
    accepted_upcoming = []
}: ToursPageProps) {
    const { url } = usePage()
    
    const getInitialTab = (): number => {
        const urlParams = new URLSearchParams(url.split('?')[1] || '')
        const tabParam = urlParams.get('tab')
        if (tabParam === 'scheduled') return 1
        if (tabParam === 'toured') return 2
        return 0
    }

    return (
        <>
            <Head title="Tours - HeyyProperty" />

            <ProspectMainLayout
                activeTab="tours"
            >
                <Box sx={{ py: 1 }}>
                    <ToursTab
                        pending_not_expired={pending_not_expired}
                        pending_expired={pending_expired}
                        accepted_past={accepted_past}
                        accepted_upcoming={accepted_upcoming}
                        initialTab={getInitialTab()}
                    />
                </Box>
            </ProspectMainLayout>
        </>
    )
}
